import { render, staticRenderFns } from "./CreateLive.vue?vue&type=template&id=17180d1c&scoped=true"
import script from "./CreateLive.vue?vue&type=script&lang=js"
export * from "./CreateLive.vue?vue&type=script&lang=js"
import style0 from "./CreateLive.vue?vue&type=style&index=0&id=17180d1c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17180d1c",
  null
  
)

export default component.exports